export default __webpack_public_path__ + "static/assets/AllianceNo2Black.e0a17749.woff";